import { makeApolloClient, logError } from '../util';
import * as ClientQueries from 'queries/client';
import * as ClientMutations from 'mutations/client';
export const FETCH_ALL_CLIENTS = 'FETCH_ALL_CLIENTS';
export const SET_CLIENT = 'SET_CLIENT';
export const UPDATE_CLIENT = 'UPDATE_CLIENT';

export const setClient = (client, from) => ({
	type: SET_CLIENT,
	client,
	from,
});

const fetchAllClients = (clients, from) => ({
	type: FETCH_ALL_CLIENTS,
	clients,
	from,
});

export const updateClient = client => ({
	type: UPDATE_CLIENT,
	client,
});

export const thunkFetchAllClients = from => async (dispatch, getState) => {
	const apolloClient = makeApolloClient(getState());
	try {
		const { clients } = await apolloClient.request(ClientQueries.CLIENTS);
		dispatch(fetchAllClients(clients, from));
	} catch (error) {
		logError(error, 'client.actions.thunkFetchAllClients');
	}
};

export const thunkCreateClient = (client, from) => async (dispatch, getState) => {
	const apolloClient = makeApolloClient(getState());
	try {
		const { createClient } = await apolloClient.request(ClientMutations.CREATE_CLIENT, { client });
		dispatch(setClient(createClient, from));
		return createClient;
	} catch (error) {
		logError(error, 'client.actions.thunkCreateClient');
	}
};

export const thunkFetchClient = (clientID, from) => async (dispatch, getState) => {
	const apolloClient = makeApolloClient(getState());
	try {
		const { client } = await apolloClient.request(ClientQueries.CLIENT, { id: clientID });
		dispatch(setClient(client, from));
	} catch (error) {
		logError(error, 'client.actions.thunkFetchClient');
	}
};
